(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-list-carousel')) {
    customElements.define('collection-list-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.clc__track');
        this.slides = [...this.querySelectorAll('.clc__slide')];
        this.controls = this.querySelector('.clc__controls');
        this.dots = this.querySelector('.clc__dots');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.abort = new AbortController();
        this.page = -1;

        const options = { signal: this.abort.signal };

        this.prev.addEventListener('click', () => this.go(this.page - 1), options);
        this.next.addEventListener('click', () => this.go(this.page + 1), options);

        this.dots.addEventListener('click', (event) => {
          const button = event.target.closest('[data-page]');
          if (button) this.go(Number(button.dataset.page));
        }, options);

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });

        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.page + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);

        this.track.addEventListener('dragstart', (event) => {
          event.preventDefault();
        }, options);

        this.track.addEventListener('pointerdown', (event) => {
          this.dragged = false;
          if (
            this.dataset.desktopSwipe !== 'true' ||
            !window.matchMedia('(min-width: 750px)').matches ||
            event.pointerType !== 'mouse' ||
            event.button !== 0
          ) return;

          this.drag = {
            id: event.pointerId,
            x: event.clientX,
            scroll: this.track.scrollLeft
          };
        }, options);

        window.addEventListener('pointermove', (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const distance = event.clientX - this.drag.x;

          if (Math.abs(distance) > 5) {
            this.dragged = true;
            this.track.classList.add('is-dragging');
          }

          if (this.dragged) {
            event.preventDefault();
            this.track.scrollLeft = this.drag.scroll - distance;
          }
        }, options);

        const endDrag = (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          this.update();
        };

        window.addEventListener('pointerup', endDrag, options);
        window.addEventListener('pointercancel', endDrag, options);

        this.track.addEventListener('click', (event) => {
          if (!this.dragged) return;
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }, { ...options, capture: true });

        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.clc__slide');
          if (!slide || !this.contains(slide)) return;
          this.track.scrollTo({
            left: this.slidePosition(slide),
            behavior: 'auto'
          });
        }, options);

        this.observer = new ResizeObserver(() => this.buildPages());
        this.observer.observe(this.track);
        this.slides.forEach((slide) => this.observer.observe(slide));
        this.buildPages();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      slidePosition(slide) {
        return slide.getBoundingClientRect().left
          - this.track.getBoundingClientRect().left
          + this.track.scrollLeft;
      }

      buildPages() {
        const width = this.track.clientWidth;
        const max = Math.max(0, this.track.scrollWidth - width);
        const positions = this.slides.map((slide) => this.slidePosition(slide));

        this.pages = [0];
        let last = 0;

        for (const position of positions) {
          const target = Math.min(position, max);
          if (target - last >= width - 1) {
            this.pages.push(target);
            last = target;
          }
        }

        if (max - last > 1) this.pages.push(max);

        this.dots.replaceChildren();
        this.pages.forEach((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'clc__dot';
          button.dataset.page = index;
          button.setAttribute('aria-label', `Go to page ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          this.dots.append(button);
        });

        this.controls.hidden = max <= 1;
        this.track.classList.toggle(
          'is-draggable',
          this.dataset.desktopSwipe === 'true' &&
          window.matchMedia('(min-width: 750px)').matches &&
          max > 1
        );

        this.update();
      }

      go(index) {
        const target = Math.max(0, Math.min(index, this.pages.length - 1));
        this.track.scrollTo({
          left: this.pages[target],
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      update() {
        if (!this.pages) return;

        const current = this.track.scrollLeft;
        let nearest = 0;

        this.pages.forEach((position, index) => {
          if (
            Math.abs(position - current) <
            Math.abs(this.pages[nearest] - current)
          ) nearest = index;
        });

        this.prev.disabled = nearest === 0;
        this.next.disabled = nearest === this.pages.length - 1;

        [...this.dots.children].forEach((dot, index) => {
          dot.setAttribute('aria-current', index === nearest ? 'true' : 'false');
        });

        if (this.page !== nearest) {
          this.page = nearest;
          this.status.textContent = `Page ${nearest + 1} of ${this.pages.length}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
